import React from 'react';
import tw, { styled } from 'twin.macro';
import { FormattedMessage } from 'gatsby-plugin-intl';

import Text from '@components/text';

const Info = styled(Text)`
  ${tw`hidden relative top-20 mb-20 sm:absolute sm:top-auto sm:-bottom-10 lg:-bottom-30`}
  ${({ error }) => (error ? tw`text-error` : tw`text-greenDark`)}

  &.show { ${tw`block`} }
`;

const Message = () => (
  <>
    <Info id="success" fontSizes={14} lineHeight={1.5}>
      <FormattedMessage id="form.messages.success" />
    </Info>
    <Info id="error" fontSizes={14} lineHeight={1.5} error>
      <FormattedMessage id="form.messages.error" />
    </Info>
  </>
);

export default Message;
